// Split out of supplier360Urls.ts (already at the 500-line limit) — company-data enrichment
// (firmographics/ext_link/suggestion/revenue_share) endpoint builders.

/** Latest snapshot per entity by default (`?history=true` for every snapshot ever retrieved). */
export function supplierFirmographicsUrl(entityId: number): string {
    return `supplier_360/firmographics/?entity=${entityId}`;
}

/** Every (entity, source) match attempt — today at most one row, for the company-data provider. */
export function supplierExtLinkUrl(entityId: number): string {
    return `supplier_360/ext_link/?entity=${entityId}`;
}

/** Spend-vs-revenue leverage for one entity — header chip and the Commercial leverage card. */
export function supplierRevenueShareUrl(entityId: number): string {
    return `supplier_360/entity/${entityId}/revenue_share/`;
}

export const SUPPLIER_SUGGESTION_URL_PREFIX = 'supplier_360/suggestion/';

/** Open and accepted domain/alias/parent suggestions for one entity — a handful at most. */
export function supplierSuggestionsUrl(entityId: number): string {
    return `${SUPPLIER_SUGGESTION_URL_PREFIX}?entity=${entityId}&state__in=open,accepted`;
}

export function supplierSuggestionDecisionUrl(suggestionId: number, decision: 'accept' | 'dismiss'): string {
    return `${SUPPLIER_SUGGESTION_URL_PREFIX}${suggestionId}/${decision}/`;
}

/** Every automated provider's own config row (show_logo/base_url/monthly_credit_cap/sync_schedule) — a handful at most. */
export function infoSourceListUrl(): string {
    return 'supplier_360/info_source/';
}
